'use strict';

angular.module('amexReconciliationApp')
  .component('advancedSearchAddRemoveCriterion', {
    templateUrl: 'scripts/views/components/advanced-search-add-remove-criterion.html',
    bindings: {
      onAdd: '&',
      onDelete: '&',
      criterion: '<',
      disableRemove: '<',
      disableAdd: '<'
    },
    controller: function () {
      var self = this;
      var removingCriterion = null;
      
      self.addCriterion = function () {
        self.onAdd({criterion: self.criterion});
      };

      self.removeCriterion = function () {
        self.onDelete({criterion: self.criterion});
      };

      self.removeConfirmation = function () {
        removingCriterion = self.criterion;
      };

      self.displayRemoveConfirmation = function () {
        return _.isEqual(self.criterion, removingCriterion) && !self.disableRemove;
      };
      
      self.cancelRemove = function() {
        removingCriterion = null;
      };
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/advancedSearchAddRemoveCriterion.js
// module id = 429
// module chunks = 0